<template>
  <el-dialog
    title="批次统计"
    :visible.sync="dialogVisible"
    fullscreen
    :close-on-click-modal="false"
    @close="handleClose"
    class="batch-statistics-dialog"
  >
    <div class="batch-statistics-container">
      <!-- 搜索条件 -->
      <div class="search-section">
        <el-form :inline="true" :model="searchForm" size="small">
          <el-form-item label="师傅维度">
            <el-select
              v-model="searchForm.installerIds"
              multiple
              filterable
              placeholder="请选择师傅"
              style="width: 200px"
              clearable
            >
              <el-option
                v-for="item in allUserList"
                :key="item.id"
                :label="item.userName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="正负激励">
            <el-select
              v-model="searchForm.incentiveTypes"
              multiple
              filterable
              placeholder="请选择正负激励"
              style="width: 200px"
              clearable
            >
              <el-option
                v-for="item in incentiveOptions"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物料费用">
            <el-select
              v-model="searchForm.materialFeeTypes"
              multiple
              filterable
              placeholder="请选择物料型号"
              style="width: 200px"
              clearable
            >
              <el-option
                v-for="item in materialOptions"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="其它费用">
            <el-select
              v-model="searchForm.otherFeeTypes"
              multiple
              filterable
              placeholder="请选择其它费用"
              style="width: 200px"
              clearable
            >
              <el-option
                v-for="item in otherFeeOptions"
                :key="item.name"
                :label="item.label"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="结算批次">
            <el-select
              v-model="searchForm.settlementBatchNames"
              multiple
              filterable
              placeholder="请选择结算批次"
              style="width: 220px"
              clearable
            >
              <el-option
                v-for="item in settlementBatchList"
                :key="item.settlementBatchName"
                :label="item.settlementBatchName"
                :value="item.settlementBatchName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 批次汇总（累计） -->
      <div class="summary-section" v-loading="summaryLoading" element-loading-text="加载中...">
        <h3>批次汇总（累计）</h3>
        <el-row :gutter="10" class="summary-row">
          <el-col :span="3">
            <div class="summary-item">
              <div class="summary-label">订单数量</div>
              <div class="summary-value">{{ summary.orderCount || 0 }}</div>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="summary-item">
              <div class="summary-label">用线米数</div>
              <div class="summary-value">{{ formatNumber(summary.totalLineLength) }}</div>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="summary-item">
              <div class="summary-label">增项费用</div>
              <div class="summary-value">¥{{ formatMoney(summary.totalAddOutlay) }}</div>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="summary-item">
              <div class="summary-label">平均米数</div>
              <div class="summary-value">{{ formatNumber(summary.avgLineLength) }}</div>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="summary-item">
              <div class="summary-label">平均增项</div>
              <div class="summary-value">¥{{ formatMoney(summary.avgAddOutlay) }}</div>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="summary-item">
              <div class="summary-label">安装费</div>
              <div class="summary-value">¥{{ formatMoney(summary.totalInstallFee) }}</div>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="summary-item">
              <div class="summary-label">管理费</div>
              <div class="summary-value">¥{{ formatMoney(summary.totalManageFee) }}</div>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="summary-item">
              <div class="summary-label">正负激励费</div>
              <div class="summary-value">¥{{ formatMoney(summary.totalIncentiveFee) }}</div>
            </div>
          </el-col>

        </el-row>
        <el-row :gutter="10" class="summary-row">
          <el-col :span="3">
            <div class="summary-item">
              <div class="summary-label">物料费用</div>
              <div class="summary-value">-¥{{ formatMoney(Math.abs(summary.totalMaterialFee || 0)) }}</div>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="summary-item">
              <div class="summary-label">其它费用</div>
              <div class="summary-value">¥{{ formatMoney(summary.totalOtherFee) }}</div>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="summary-item">
              <div class="summary-label">公司提成</div>
              <div class="summary-value">¥{{ formatMoney(summary.totalCommissionFee) }}</div>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="summary-item">
              <div class="summary-label">
                批次总应付
                <el-tooltip
                  effect="dark"
                  placement="top"
                  content="批次总应付 = 安装费 + 正负激励费 + 管理费 + 其它费用 - 物料费 - 公司提成"
                >
                  <i class="el-icon-question summary-tip-icon"></i>
                </el-tooltip>
              </div>
              <div class="summary-value">¥{{ formatMoney(batchTotalPayable) }}</div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 批次明细 -->
      <div class="batch-details-section" v-loading="batchDetailsLoading" element-loading-text="加载中...">
        <h3>批次明细</h3>
        <el-table
          :data="batchDetails"
          stripe
          size="small"
          max-height="300"
          :header-cell-style="{
            'background-color': '#84aace4a',
            color: '#343333',
            'text-align': 'center',
          }"
          :cell-style="{ 'text-align': 'center' }"
        >
          <el-table-column prop="settlementBatchName" label="批次名称" width="150"></el-table-column>
          <el-table-column prop="orderCount" label="订单数量" width="100">
            <template slot-scope="scope">{{ scope.row.orderCount || 0 }}</template>
          </el-table-column>
          <el-table-column prop="lineLength" label="用线米数">
            <template slot-scope="scope">{{ formatNumber(scope.row.lineLength) }}</template>
          </el-table-column>
          <el-table-column prop="addOutlay" label="增项费用">
            <template slot-scope="scope">¥{{ formatMoney(scope.row.addOutlay) }}</template>
          </el-table-column>
          <el-table-column prop="avgLineLength" label="平均米数">
            <template slot-scope="scope">{{ formatNumber(scope.row.avgLineLength) }}</template>
          </el-table-column>
          <el-table-column prop="avgAddOutlay" label="平均增项">
            <template slot-scope="scope">¥{{ formatMoney(scope.row.avgAddOutlay) }}</template>
          </el-table-column>
          <el-table-column prop="installFee" label="安装费">
            <template slot-scope="scope">¥{{ formatMoney(scope.row.installFee) }}</template>
          </el-table-column>
          <el-table-column prop="manageFee" label="管理费">
            <template slot-scope="scope">¥{{ formatMoney(scope.row.manageFee) }}</template>
          </el-table-column>
          <el-table-column prop="incentiveFee" label="正负激励费">
            <template slot-scope="scope">¥{{ formatMoney(scope.row.incentiveFee) }}</template>
          </el-table-column>
          <el-table-column prop="materialFee" label="物料费用">
            <template slot-scope="scope"> <span v-if="scope.row.materialFee>0">-</span>¥{{ formatMoney(Math.abs(scope.row.materialFee || 0)) }}</template>
          </el-table-column>
          <el-table-column prop="otherFee" label="其它费用">
            <template slot-scope="scope">¥{{ formatMoney(scope.row.otherFee) }}</template>
          </el-table-column>
          <el-table-column prop="commissionFee" label="公司提成">
            <template slot-scope="scope">¥{{ formatMoney(scope.row.commissionFee) }}</template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          :total="batchDetailsTotal"
          :page-sizes="pageSizes"
          :page-size="batchDetailsPageSize"
          :current-page.sync="batchDetailsPageNum"
          @current-change="handleBatchDetailsPageChange"
          @size-change="handleBatchDetailsSizeChange"
          style="margin-top: 10px; text-align: right"
        ></el-pagination>
      </div>

      <!-- 师傅订单 -->
      <div class="installer-orders-section" v-loading="installerOrdersLoading" element-loading-text="加载中...">
        <h3>师傅订单</h3>
        <el-table
          :data="installerOrders"
          stripe
          size="small"
          max-height="400"
          :header-cell-style="{
            'background-color': '#84aace4a',
            color: '#343333',
            'text-align': 'center',
          }"
          :cell-style="{ 'text-align': 'center' }"
        >
          <el-table-column prop="installerName" label="师傅名称" width="120">
            <template slot-scope="scope">
              <span 
                style="color: #409eff; cursor: pointer; text-decoration: underline;"
                @click="showOrderDetailsDialog(scope.row)"
              >{{ scope.row.installerName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="orderCount" label="订单数量" width="100">
            <template slot-scope="scope">{{ scope.row.orderCount || 0 }}</template>
          </el-table-column>
          <el-table-column prop="lineLength" label="用线米数">
            <template slot-scope="scope">{{ formatNumber(scope.row.lineLength) }}</template>
          </el-table-column>
          <el-table-column prop="addOutlay" label="增项费用">
            <template slot-scope="scope">¥{{ formatMoney(scope.row.addOutlay) }}</template>
          </el-table-column>
          <el-table-column prop="avgLineLength" label="平均米数">
            <template slot-scope="scope">{{ formatNumber(scope.row.avgLineLength) }}</template>
          </el-table-column>
          <el-table-column prop="avgAddOutlay" label="平均增项">
            <template slot-scope="scope">¥{{ formatMoney(scope.row.avgAddOutlay) }}</template>
          </el-table-column>
          <el-table-column prop="installFee" label="安装费">
            <template slot-scope="scope">¥{{ formatMoney(scope.row.installFee) }}</template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          :total="installerOrdersTotal"
          :page-sizes="pageSizes"
          :page-size="installerOrdersPageSize"
          :current-page.sync="installerOrdersPageNum"
          @current-change="handleInstallerOrdersPageChange"
          @size-change="handleInstallerOrdersSizeChange"
          style="margin-top: 10px; text-align: right"
        ></el-pagination>
      </div>

      <!-- 师傅结算汇总 -->
      <div class="installer-settlement-section" v-loading="installerSettlementLoading" element-loading-text="加载中...">
        <h3>师傅结算汇总</h3>
        <div v-for="settlement in installerSettlement" :key="settlement.installerId" class="installer-settlement-item">
          <div class="installer-settlement-header">
            <strong>{{ settlement.installerName }}</strong>
          </div>
          <el-row :gutter="10">
            <el-col :span="4">
              <div class="settlement-item">
                正负激励费：
                <span 
                  :class="['settlement-amount', { 'clickable': settlement.incentiveFee && settlement.incentiveFee != 0, 'disabled': !settlement.incentiveFee || settlement.incentiveFee == 0 }]" 
                  @click="settlement.incentiveFee && settlement.incentiveFee != 0 ? toggleFeeGroups(settlement, 'incentive') : null">
                  <i v-if="settlement.incentiveFee && settlement.incentiveFee != 0" :class="settlement.incentiveExpanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" style="margin-right: 3px;"></i>
                  ¥{{ formatMoney(settlement.incentiveFee) }}
                </span>
                <!-- 展开分组 -->
                <div v-if="settlement.incentiveExpanded" class="fee-group-list">
                  <div v-for="(group, index) in settlement.incentiveGroups" :key="`incentive_${settlement.installerId}_${group.uniqueKey || group.groupKey || ''}_${index}`" class="fee-group-item">
                    <span>{{ group.groupName }}：¥{{ formatMoney(group.totalAmount) }}</span>
                    <el-button type="text" size="mini" @click="showFeeDetails(settlement.installerId, 'incentive', group.groupKey)">详细</el-button>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="settlement-item">
                物料费用：
                <span 
                  :class="['settlement-amount', { 'clickable': settlement.materialFee && settlement.materialFee != 0, 'disabled': !settlement.materialFee || settlement.materialFee == 0 }]" 
                  @click="settlement.materialFee && settlement.materialFee != 0 ? toggleFeeGroups(settlement, 'material') : null">
                  <i v-if="settlement.materialFee && settlement.materialFee != 0" :class="settlement.materialExpanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" style="margin-right: 3px;"></i>
                  -¥{{ formatMoney(Math.abs(settlement.materialFee || 0)) }}
                </span>
                <!-- 展开分组 -->
                <div v-if="settlement.materialExpanded" class="fee-group-list">
                  <div v-for="(group, index) in settlement.materialGroups" :key="`material_${settlement.installerId}_${group.uniqueKey || group.groupKey || ''}_${index}`" class="fee-group-item">
                    <span>{{ group.groupName }}：-¥{{ formatMoney(Math.abs(group.totalAmount || 0)) }}</span>
                    <el-button type="text" size="mini" @click="showFeeDetails(settlement.installerId, 'material', group.groupKey)">详细</el-button>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="settlement-item">
                其它费用：
                <span 
                  :class="['settlement-amount', { 'clickable': settlement.otherFee && settlement.otherFee != 0, 'disabled': !settlement.otherFee || settlement.otherFee == 0 }]" 
                  @click="settlement.otherFee && settlement.otherFee != 0 ? toggleFeeGroups(settlement, 'other') : null">
                  <i v-if="settlement.otherFee && settlement.otherFee != 0" :class="settlement.otherExpanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" style="margin-right: 3px;"></i>
                  ¥{{ formatMoney(settlement.otherFee) }}
                </span>
                <!-- 展开分组 -->
                <div v-if="settlement.otherExpanded" class="fee-group-list">
                  <div v-for="(group, index) in settlement.otherGroups" :key="`other_${settlement.installerId}_${group.uniqueKey || group.groupKey || ''}_${group.type || 0}_${index}`" class="fee-group-item">
                    <span>{{ group.groupName }}：¥{{ formatMoney(group.totalAmount) }}</span>
                    <el-button type="text" size="mini" @click="showFeeDetails(settlement.installerId, 'other', group.groupKey, group.type)">详细</el-button>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="settlement-item">
                增项提成：
                <span 
                  :class="['settlement-amount', { 'clickable': settlement.commissionFee && settlement.commissionFee != 0, 'disabled': !settlement.commissionFee || settlement.commissionFee == 0 }]" 
                  @click="settlement.commissionFee && settlement.commissionFee != 0 ? showCommissionDetails(settlement, 'commission') : null">
                  ¥{{ formatMoney(settlement.commissionFee) }}
                </span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="settlement-item">
                被增项提成：
                <span 
                  :class="['settlement-amount', { 'clickable': settlement.installerCommissionFee && settlement.installerCommissionFee != 0, 'disabled': !settlement.installerCommissionFee || settlement.installerCommissionFee == 0 }]" 
                  @click="settlement.installerCommissionFee && settlement.installerCommissionFee != 0 ? showCommissionDetails(settlement, 'installerCommission') : null">
                  -¥{{ formatMoney(Math.abs(settlement.installerCommissionFee || 0)) }}
                </span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="settlement-item">
                管理费：
                <span 
                  :class="['settlement-amount', { 'clickable': settlement.manageFee && settlement.manageFee != 0, 'disabled': !settlement.manageFee || settlement.manageFee == 0 }]" 
                  @click="settlement.manageFee && settlement.manageFee != 0 ? showManageFeeDetails(settlement) : null">
                  ¥{{ formatMoney(settlement.manageFee) }}
                </span>
              </div>
            </el-col>
          </el-row>
        </div>
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          :total="installerSettlementTotal"
          :page-sizes="pageSizes"
          :page-size="installerSettlementPageSize"
          :current-page.sync="installerSettlementPageNum"
          @current-change="handleInstallerSettlementPageChange"
          @size-change="handleInstallerSettlementSizeChange"
          style="margin-top: 10px; text-align: right"
        ></el-pagination>
      </div>
    </div>

    <!-- 费用详情弹窗 -->
    <el-dialog
      :title="getFeeDetailsTitle()"
      :visible.sync="feeDetailsDialogVisible"
      width="60%"
      append-to-body
    >
      <el-table
        :data="feeDetails"
        stripe
        size="small"
        :header-cell-style="{
          'background-color': '#84aace4a',
          color: '#343333',
          'text-align': 'center',
        }"
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column prop="settlementBatchName" label="批次名称"></el-table-column>
        <el-table-column prop="feeName" label="费用名称"></el-table-column>
        <!-- 正负激励和其它费用：显示正负字段 -->
        <el-table-column v-if="currentFeeType === 'incentive' || currentFeeType === 'other'" prop="incentiveType" label="正负">
          <template slot-scope="scope">
            <span :style="{ color: isPositiveIncentive(scope.row.incentiveType) ? '#67C23A' : '#F56C6C' }">
              {{ isPositiveIncentive(scope.row.incentiveType) ? '正' : '负' }}
            </span>
          </template>
        </el-table-column>
        <!-- 物料费用：显示物料名称 -->
        <el-table-column v-if="currentFeeType === 'material'" prop="materialName" label="物料名称"></el-table-column>
        <el-table-column prop="amount" label="金额">
          <template slot-scope="scope">
            <span v-if="currentFeeType === 'material'">
              -¥{{ formatMoney(Math.abs(scope.row.amount || 0)) }}
            </span>
            <span v-else-if="(currentFeeType === 'incentive' || currentFeeType === 'other') && !isPositiveIncentive(scope.row.incentiveType)">
              -¥{{ formatMoney(Math.abs(scope.row.amount || 0)) }}
            </span>
            <span v-else>
              ¥{{ formatMoney(scope.row.amount) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="installerName" label="对应师傅"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
      </el-table>
    </el-dialog>

    <!-- 订单详情弹窗 -->
    <el-dialog
      :title="currentInstallerRow ? `${currentInstallerRow.installerName} - 订单详情` : '订单详情'"
      :visible.sync="orderDetailsDialogVisible"
      width="75%"
      append-to-body
      class="order-details-dialog"
    >
      <div class="order-details-container">
        <div class="order-details-table-wrapper">
          <el-table
            :data="currentOrderDetails"
            stripe
            size="small"
            height="100%"
            :header-cell-style="{
              'background-color': '#84aace4a',
              color: '#343333',
              'text-align': 'center',
            }"
            :cell-style="{ 'text-align': 'center' }"
          >
        <el-table-column prop="companyName" label="公司" width="120"></el-table-column>
        <el-table-column prop="brandName" label="品牌" width="100"></el-table-column>
        <el-table-column prop="modelName" label="车型" width="120"></el-table-column>
        <el-table-column prop="mainOrderNo" label="主机订单号" width="150"></el-table-column>
        <el-table-column prop="upstreamOrderNo" label="上游订单号" width="150"></el-table-column>
        <el-table-column prop="customerName" label="客户名称" width="100"></el-table-column>
        <el-table-column prop="contactPhone" label="联系方式" width="120"></el-table-column>
        <el-table-column prop="lineLength" label="米数">
          <template slot-scope="scope">{{ formatNumber(scope.row.lineLength) }}</template>
        </el-table-column>
        <el-table-column prop="addOutlay" label="增项费用">
          <template slot-scope="scope">¥{{ formatMoney(scope.row.addOutlay) }}</template>
        </el-table-column>
        <el-table-column prop="installFee" label="安装费">
          <template slot-scope="scope">¥{{ formatMoney(scope.row.installFee) }}</template>
        </el-table-column>
      </el-table>
      </div>
      <el-pagination
        v-if="currentOrderDetailsTotal > orderDetailsPageSize"
        background
        layout="total, sizes, prev, pager, next"
        :total="currentOrderDetailsTotal"
        :page-sizes="pageSizes"
        :page-size="orderDetailsPageSize"
        :current-page.sync="currentOrderDetailsPageNum"
        @current-change="handleOrderDetailsDialogPageChange"
        @size-change="handleOrderDetailsSizeChange"
        style="margin-top: 10px; text-align: right"
      >      </el-pagination>
      </div>
    </el-dialog>

    <!-- 提成详情弹窗 -->
    <el-dialog
      :title="currentCommissionTitle"
      :visible.sync="commissionDetailsDialogVisible"
      width="80%"
      append-to-body
      class="commission-details-dialog"
    >
      <div class="commission-details-container">
        <el-table
          :data="commissionDetails"
          stripe
          size="small"
          max-height="500"
          :header-cell-style="{
            'background-color': '#84aace4a',
            color: '#343333',
            'text-align': 'center',
          }"
          :cell-style="{ 'text-align': 'center' }"
        >
          <el-table-column type="index" label="序号" ></el-table-column>
          <el-table-column prop="orderCount" label="订单数量" >
            <template slot-scope="scope">{{ scope.row.orderCount || 0 }}</template>
          </el-table-column>
          <el-table-column prop="commissionUserName" label="提成人" ></el-table-column>
          <el-table-column prop="installerName" label="被提成人" ></el-table-column>
          <!-- <el-table-column prop="totalAddOutlay" label="增项金额">
            <template slot-scope="scope">¥{{ formatMoney(scope.row.totalAddOutlay) }}</template>
          </el-table-column> -->
          <el-table-column prop="totalCommissionAmount" label="提成金额" >
            <template slot-scope="scope">¥{{ formatMoney(scope.row.totalCommissionAmount) }}</template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!-- 管理费详情弹窗 -->
    <el-dialog
      :title="currentManageFeeTitle"
      :visible.sync="manageFeeDetailsDialogVisible"
      width="60%"
      append-to-body
    >
      <el-table
        :data="manageFeeDetails"
        stripe
        size="small"
        max-height="500"
        :header-cell-style="{
          'background-color': '#84aace4a',
          color: '#343333',
          'text-align': 'center',
        }"
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column prop="installerName" label="安装师傅"></el-table-column>
        <el-table-column prop="orderCount" label="数量">
          <template slot-scope="scope">{{ scope.row.orderCount || 0 }}</template>
        </el-table-column>
        <el-table-column prop="totalAmount" label="金额">
          <template slot-scope="scope">¥{{ formatMoney(scope.row.totalAmount) }}</template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </el-dialog>
</template>

<script>
export default {
  name: "BatchStatisticsDialog",
  props: {
    settlementBatchList: {
      type: Array,
      default: () => [],
    },
    allUserList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    batchTotalPayable() {
      const toNum = (val) => {
        if (val == null || val === undefined || val === "") {
          return 0;
        }
        const num = typeof val === "string" ? parseFloat(val) : Number(val);
        return Number.isNaN(num) ? 0 : num;
      };
      const install = toNum(this.summary.totalInstallFee);
      const incentive = toNum(this.summary.totalIncentiveFee);
      const manage = toNum(this.summary.totalManageFee);
      const other = toNum(this.summary.totalOtherFee);
      const material = Math.abs(toNum(this.summary.totalMaterialFee));
      const commission = toNum(this.summary.totalCommissionFee);
      const total = install + incentive + manage + other - material - commission;
      return Number(total.toFixed(2));
    },
  },
  data() {
    return {
      dialogVisible: false,
      searchForm: {
        installerIds: [],
        incentiveTypes: [],
        materialFeeTypes: [],
        otherFeeTypes: [],
        settlementBatchNames: [],
      },
      summary: {
        totalLineLength: 0,
        totalAddOutlay: 0,
        avgLineLength: 0,
        avgAddOutlay: 0,
        totalInstallFee: 0,
        totalManageFee: 0,
        totalIncentiveFee: 0,
        totalMaterialFee: 0,
        totalOtherFee: 0,
        totalCommissionFee: 0,
      },
      batchDetails: [],
      batchDetailsTotal: 0,
      batchDetailsPageNum: 1,
      batchDetailsPageSize: 10,
      pageSizes: [10, 15, 20, 30, 50, 100],
      installerOrders: [],
      installerOrdersTotal: 0,
      installerOrdersPageNum: 1,
      installerOrdersPageSize: 20,
      orderDetailsPageSize: 20,
      installerSettlement: [],
      installerSettlementTotal: 0,
      installerSettlementPageNum: 1,
      installerSettlementPageSize: 10,
      feeDetailsDialogVisible: false,
      feeDetails: [],
      currentFeeType: '', // 当前费用类型（incentive/material/other）
      orderDetailsDialogVisible: false,
      currentOrderDetails: [],
      currentOrderDetailsTotal: 0,
      currentOrderDetailsPageNum: 1,
      currentInstallerRow: null, // 当前查看订单详情的师傅行数据
      commissionDetailsDialogVisible: false,
      commissionDetails: [],
      currentCommissionTitle: '',
      currentCommissionType: '', // commission 或 installerCommission
      manageFeeDetailsDialogVisible: false,
      manageFeeDetails: [],
      currentManageFeeTitle: '',
      incentiveOptions: [],
      materialOptions: [],
      otherFeeOptions: [],
      // Loading 状态
      summaryLoading: false,
      batchDetailsLoading: false,
      installerOrdersLoading: false,
      installerSettlementLoading: false,
    };
  },
  created() {
    this.loadSearchOptions();
  },
  methods: {
    loadSearchOptions() {
      this.axios({
        method: "get",
        url: "/settlement-report/batch-statistics/search-options",
      }).then((res) => {
        if (res.data.code === 200) {
          this.incentiveOptions = res.data.data.incentiveOptions || [];
          this.materialOptions = res.data.data.materialOptions || [];
          this.otherFeeOptions = res.data.data.otherFeeOptions || [];
        } else {
          this.$message.error(res.data.message || "获取搜索选项失败");
        }
      }).catch((err) => {
        console.error("获取搜索选项失败:", err);
      });
    },
    open(batchNames = []) {
      this.dialogVisible = true;
      if (batchNames && batchNames.length > 0) {
        this.searchForm.settlementBatchNames = batchNames;
      }
      this.handleSearch();
    },
    handleClose() {
      this.dialogVisible = false;
      this.resetData();
    },
    handleSearch() {
      this.getSummary();
      this.getBatchDetails();
      this.getInstallerOrders();
      this.getInstallerSettlement();
    },
    handleReset() {
      this.searchForm = {
        installerIds: [],
        incentiveTypes: [],
        materialFeeTypes: [],
        otherFeeTypes: [],
        settlementBatchNames: [],
      };
      this.handleSearch();
    },
    resetData() {
      this.summary = {
        totalLineLength: 0,
        totalAddOutlay: 0,
        avgLineLength: 0,
        avgAddOutlay: 0,
        totalInstallFee: 0,
        totalManageFee: 0,
        totalIncentiveFee: 0,
        totalMaterialFee: 0,
        totalOtherFee: 0,
        totalCommissionFee: 0,
      };
      this.batchDetails = [];
      this.batchDetailsTotal = 0;
      this.batchDetailsPageNum = 1;
      this.installerOrders = [];
      this.installerOrdersTotal = 0;
      this.installerOrdersPageNum = 1;
      this.installerSettlement = [];
      this.installerSettlementTotal = 0;
      this.installerSettlementPageNum = 1;
      // 重置 loading 状态
      this.summaryLoading = false;
      this.batchDetailsLoading = false;
      this.installerOrdersLoading = false;
      this.installerSettlementLoading = false;
    },
    getSummary() {
      this.summaryLoading = true;
      this.axios({
        method: "post",
        url: "/settlement-report/batch-statistics/summary",
        data: this.searchForm,
      }).then((res) => {
        if (res.data.code === 200) {
          this.summary = res.data.data;
        } else {
          this.$message.error(res.data.message || "获取批次汇总数据失败");
        }
      }).catch((err) => {
        console.error("获取批次汇总数据失败:", err);
        this.$message.error("网络错误，请稍后重试");
      }).finally(() => {
        this.summaryLoading = false;
      });
    },
    getBatchDetails() {
      this.batchDetailsLoading = true;
      const params = {
        ...this.searchForm,
        pageNum: this.batchDetailsPageNum,
        pageSize: this.batchDetailsPageSize,
      };
      this.axios({
        method: "post",
        url: "/settlement-report/batch-statistics/batch-details",
        data: params,
      }).then((res) => {
        if (res.data.code === 200) {
          this.batchDetails = res.data.data.list || [];
          this.batchDetailsTotal = res.data.data.total || 0;
        } else {
          this.$message.error(res.data.message || "获取批次明细数据失败");
        }
      }).catch((err) => {
        console.error("获取批次明细数据失败:", err);
        this.$message.error("网络错误，请稍后重试");
      }).finally(() => {
        this.batchDetailsLoading = false;
      });
    },
    handleBatchDetailsPageChange(page) {
      this.batchDetailsPageNum = page;
      this.getBatchDetails();
    },
    handleBatchDetailsSizeChange(size) {
      this.batchDetailsPageSize = size;
      this.batchDetailsPageNum = 1;
      this.getBatchDetails();
    },
    getInstallerOrders() {
      this.installerOrdersLoading = true;
      const params = {
        ...this.searchForm,
        pageNum: this.installerOrdersPageNum,
        pageSize: this.installerOrdersPageSize,
      };
      this.axios({
        method: "post",
        url: "/settlement-report/batch-statistics/installer-orders",
        data: params,
      }).then((res) => {
        if (res.data.code === 200) {
          this.installerOrders = res.data.data.list || [];
          this.installerOrdersTotal = res.data.data.total || 0;
        } else {
          this.$message.error(res.data.message || "获取师傅订单数据失败");
        }
      }).catch((err) => {
        console.error("获取师傅订单数据失败:", err);
        this.$message.error("网络错误，请稍后重试");
      }).finally(() => {
        this.installerOrdersLoading = false;
      });
    },
    handleInstallerOrdersPageChange(page) {
      this.installerOrdersPageNum = page;
      this.getInstallerOrders();
    },
    handleInstallerOrdersSizeChange(size) {
      this.installerOrdersPageSize = size;
      this.installerOrdersPageNum = 1;
      this.getInstallerOrders();
    },
    loadInstallerOrderDetails(installerRow) {
      if (installerRow.orderDetailsLoaded && installerRow.orderDetailsPageNum === 1) {
        return;
      }
      
      const params = {
        ...this.searchForm,
        pageNum: installerRow.orderDetailsPageNum || 1,
        pageSize: this.orderDetailsPageSize,
      };
      
      this.axios({
        method: "post",
        url: "/settlement-report/batch-statistics/installer-order-details",
        params: { installerId: installerRow.installerId },
        data: params,
      }).then((res) => {
        if (res.data.code === 200) {
          installerRow.orderDetails = res.data.data.list || [];
          installerRow.orderDetailsTotal = res.data.data.total || 0;
          installerRow.orderDetailsLoaded = true;
          this.$forceUpdate();
        } else {
          this.$message.error(res.data.message || "获取订单详情失败");
        }
      }).catch((err) => {
        console.error("获取订单详情失败:", err);
        this.$message.error("网络错误，请稍后重试");
      });
    },
    handleOrderDetailsPageChange(installerRow) {
      installerRow.orderDetailsLoaded = false;
      this.loadInstallerOrderDetails(installerRow);
    },
    showOrderDetailsDialog(row) {
      this.currentInstallerRow = row;
      this.currentOrderDetailsPageNum = 1;
      this.currentOrderDetails = [];
      this.currentOrderDetailsTotal = 0;
      this.orderDetailsDialogVisible = true;
      // 加载订单详情
      this.loadOrderDetailsForDialog(row);
    },
    loadOrderDetailsForDialog(installerRow) {
      const params = {
        ...this.searchForm,
        pageNum: this.currentOrderDetailsPageNum,
        pageSize: this.orderDetailsPageSize,
      };
      
      this.axios({
        method: "post",
        url: "/settlement-report/batch-statistics/installer-order-details",
        params: { installerId: installerRow.installerId },
        data: params,
      }).then((res) => {
        if (res.data.code === 200) {
          this.currentOrderDetails = res.data.data.list || [];
          this.currentOrderDetailsTotal = res.data.data.total || 0;
        } else {
          this.$message.error(res.data.message || "获取订单详情失败");
        }
      }).catch((err) => {
        console.error("获取订单详情失败:", err);
        this.$message.error("网络错误，请稍后重试");
      });
    },
    handleOrderDetailsDialogPageChange(page) {
      this.currentOrderDetailsPageNum = page;
      if (this.currentInstallerRow) {
        this.loadOrderDetailsForDialog(this.currentInstallerRow);
      }
    },
    handleOrderDetailsSizeChange(size) {
      this.orderDetailsPageSize = size;
      this.currentOrderDetailsPageNum = 1;
      if (this.currentInstallerRow) {
        this.loadOrderDetailsForDialog(this.currentInstallerRow);
      }
    },
    showCommissionDetails(settlement, commissionType) {
      this.currentCommissionType = commissionType;
      this.currentCommissionTitle = commissionType === 'commission' 
        ? `${settlement.installerName} - 增项提成详情`
        : `${settlement.installerName} - 被增项提成详情`;
      this.commissionDetails = [];
      this.commissionDetailsDialogVisible = true;
      
      // 加载提成详情
      const params = {
        ...this.searchForm,
      };
      
      this.axios({
        method: "post",
        url: "/settlement-report/batch-statistics/commission-details",
        params: { 
          installerId: settlement.installerId, 
          commissionType: commissionType 
        },
        data: params,
      }).then((res) => {
        if (res.data.code === 200) {
          this.commissionDetails = res.data.data || [];
        } else {
          this.$message.error(res.data.message || "获取提成详情失败");
        }
      }).catch((err) => {
        console.error("获取提成详情失败:", err);
        this.$message.error("网络错误，请稍后重试");
      });
    },
    showManageFeeDetails(settlement) {
      this.currentManageFeeTitle = `${settlement.installerName} - 管理费详情`;
      this.manageFeeDetails = [];
      this.manageFeeDetailsDialogVisible = true;
      
      // 加载管理费详情
      this.axios({
        method: "post",
        url: "/settlement-report/batch-statistics/installer-fee-groups",
        params: { installerId: settlement.installerId, feeType: 'manage' },
        data: this.searchForm,
      }).then((res) => {
        if (res.data.code === 200) {
          this.manageFeeDetails = res.data.data || [];
        } else {
          this.$message.error(res.data.message || "获取管理费详情失败");
        }
      }).catch((err) => {
        console.error("获取管理费详情失败:", err);
        this.$message.error("网络错误，请稍后重试");
      });
    },
    getInstallerSettlement() {
      this.installerSettlementLoading = true;
      const params = {
        ...this.searchForm,
        pageNum: this.installerSettlementPageNum,
        pageSize: this.installerSettlementPageSize,
      };
      this.axios({
        method: "post",
        url: "/settlement-report/batch-statistics/installer-settlement",
        data: params,
      }).then((res) => {
        if (res.data.code === 200) {
          this.installerSettlement = (res.data.data.list || []).map(item => ({
            ...item,
            incentiveExpanded: false,
            incentiveGroups: [],
            materialExpanded: false,
            materialGroups: [],
            otherExpanded: false,
            otherGroups: [],
          }));
          this.installerSettlementTotal = res.data.data.total || 0;
        } else {
          this.$message.error(res.data.message || "获取师傅结算汇总数据失败");
        }
      }).catch((err) => {
        console.error("获取师傅结算汇总数据失败:", err);
        this.$message.error("网络错误，请稍后重试");
      }).finally(() => {
        this.installerSettlementLoading = false;
      });
    },
    handleInstallerSettlementPageChange(page) {
      this.installerSettlementPageNum = page;
      this.getInstallerSettlement();
    },
    handleInstallerSettlementSizeChange(size) {
      this.installerSettlementPageSize = size;
      this.installerSettlementPageNum = 1;
      this.getInstallerSettlement();
    },
    toggleFeeGroups(settlement, feeType) {
      const expandedKey = feeType + 'Expanded';
      const groupsKey = feeType + 'Groups';
      
      // 切换展开状态
      settlement[expandedKey] = !settlement[expandedKey];
      
      // 如果展开且还没有加载数据，则加载分组数据
      if (settlement[expandedKey] && settlement[groupsKey].length === 0) {
        this.axios({
          method: "post",
          url: "/settlement-report/batch-statistics/installer-fee-groups",
          params: { installerId: settlement.installerId, feeType },
          data: this.searchForm,
        }).then((res) => {
          if (res.data.code === 200) {
            const groups = res.data.data || [];
            console.log("获取费用分组数据:", feeType, groups);
            settlement[groupsKey] = groups;
            this.$forceUpdate();
          } else {
            this.$message.error(res.data.message || "获取费用分组失败");
          }
        }).catch((err) => {
          console.error("获取费用分组失败:", err);
          this.$message.error("网络错误，请稍后重试");
        });
      } else {
        this.$forceUpdate();
      }
    },
    showFeeDetails(installerId, feeType, groupKey, incentiveType) {
      this.currentFeeType = feeType; // 保存当前费用类型
      this.axios({
        method: "post",
        url: "/settlement-report/batch-statistics/fee-details",
        params: { installerId, feeType, groupKey: groupKey || '', incentiveType: incentiveType || '' },
        data: this.searchForm,
      }).then((res) => {
        if (res.data.code === 200) {
          this.feeDetails = res.data.data.details || [];
          // 调试：打印第一条数据的 incentiveType
          if (this.feeDetails.length > 0 && this.currentFeeType === 'incentive') {
            console.log('正负激励费详情数据示例:', this.feeDetails[0]);
            console.log('incentiveType 值:', this.feeDetails[0].incentiveType, '类型:', typeof this.feeDetails[0].incentiveType);
          }
          this.feeDetailsDialogVisible = true;
        } else {
          this.$message.error(res.data.message || "获取费用详情失败");
        }
      }).catch((err) => {
        console.error("获取费用详情失败:", err);
        this.$message.error("网络错误，请稍后重试");
      });
    },
    getFeeDetailsTitle() {
      const titleMap = {
        incentive: '正负激励费详情',
        material: '物料费用详情',
        other: '其它费用详情'
      };
      return titleMap[this.currentFeeType] || '费用详情';
    },
    isPositiveIncentive(incentiveType) {
      // 判断是否为正激励：1 表示正，0 或其他值表示负
      // 处理可能的字符串类型
      if (incentiveType === null || incentiveType === undefined) {
        return false;
      }
      // 转换为数字进行比较
      const type = typeof incentiveType === 'string' ? parseInt(incentiveType, 10) : incentiveType;
      return type === 1;
    },
    formatMoney(value) {
      if (value == null || value === undefined || value === '') {
        return '0.00';
      }
      const num = typeof value === 'string' ? parseFloat(value) : value;
      if (isNaN(num)) {
        return '0.00';
      }
      return num.toFixed(2);
    },
    formatNumber(value) {
      if (value == null || value === undefined || value === '') {
        return '0';
      }
      const num = typeof value === 'string' ? parseFloat(value) : value;
      if (isNaN(num)) {
        return '0';
      }
      return num.toFixed(2);
    },
  },
};
</script>

<style scoped   lang="scss">
.batch-statistics-container {
  padding: 10px;
  padding-top: 0px;
}

.search-section {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.summary-section {
  margin-bottom: 20px;
}

.summary-section h3 {
  margin: 0 0 15px 0;
  font-size: 16px;
  font-weight: bold;
  text-align: left;
}

.summary-row {
  margin-bottom: 10px;
}

.summary-item {
  padding: 10px;
  background-color: #ecf5ff;
  border-radius: 4px;
  text-align: center;
}

.summary-label {
  font-size: 12px;
  color: #606266;
  margin-bottom: 5px;
}

.summary-tip-icon {
  margin-left: 4px;
  color: #909399;
  cursor: pointer;
  font-size: 14px;
  vertical-align: middle;
}

.summary-value {
  font-size: 16px;
  font-weight: bold;
  color: #409eff;
}

.batch-details-section,
.installer-orders-section,
.installer-settlement-section {
  margin-bottom: 20px;
}

.batch-details-section h3,
.installer-orders-section h3,
.installer-settlement-section h3 {
  margin: 0 0 10px 0;
  font-size: 16px;
  font-weight: bold;
  text-align: left;
}

.installer-order-details {
  padding: 15px;
  background-color: #fafafa;
}

.installer-settlement-item {
  margin-bottom: 15px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
}

.installer-settlement-header {
  margin-bottom: 10px;
  font-size: 14px;
}

.settlement-item {
  padding: 8px;
  font-size: 13px;
}

.settlement-amount {
  color: #409eff;
  font-weight: bold;
  margin-right: 5px;
}

.settlement-amount.clickable {
  cursor: pointer;
  user-select: none;
}

.settlement-amount.clickable:hover {
  text-decoration: underline;
}

.settlement-amount.disabled {
  color: #c0c4cc;
  cursor: not-allowed;
}

.fee-group-list {
  margin-top: 8px;
  padding-left: 20px;
}

.fee-group-item {
  padding: 5px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  color: #606266;
}

.fee-group-item span {
  flex: 1;
}
</style>

<style>
.batch-statistics-dialog .el-dialog {
  margin: 0 !important;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.batch-statistics-dialog .el-dialog__header {
  flex-shrink: 0;
  padding: 20px;
  border-bottom: 1px solid #e4e7ed;
}

.batch-statistics-dialog .el-dialog__body {
  padding: 0 !important;
  overflow: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.batch-statistics-container {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px;
}

/* 订单详情弹窗样式 */
.order-details-dialog .el-dialog {
  height: 95vh;
  display: flex;
  flex-direction: column;
  margin-bottom: 0 !important;
  margin-top: 10px  !important;
}

.order-details-dialog .el-dialog__header {
  flex-shrink: 0;
  padding: 20px;
  border-bottom: 1px solid #e4e7ed;
}

.order-details-dialog .el-dialog__body {
  padding: 20px !important;
  overflow: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.order-details-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.order-details-table-wrapper {
  flex: 1;
  overflow: hidden;
  min-height: 0;
}

.order-details-table-wrapper .el-table {
  height: 100%;
}

.order-details-container .el-pagination {
  flex-shrink: 0;
  margin-top: 10px;
}
</style>

